import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WebAppConfigService } from '../services/webapp-config.service';

/**
 * Guard que verifica si el sitio está en modo mantenimiento.
 * 
 * Si la configuración web tiene en_mantenimiento = true,
 * redirige a la página de mantenimiento.
 * 
 * Uso en rutas:
 * {
 *   path: 'home',
 *   component: HomeComponent,
 *   canActivate: [maintenanceGuard]
 * }
 */
export const maintenanceGuard: CanActivateFn = (route, state) => {
  const webAppConfigService = inject(WebAppConfigService);
  const router = inject(Router);

  // Obtener la configuración actual
  const config = webAppConfigService.config();

  // Debug: Log detallado
  console.log('🔍 maintenanceGuard - Verificando estado:', {
    url: state.url,
    config: config,
    en_mantenimiento: config?.en_mantenimiento,
    tipo: typeof config?.en_mantenimiento
  });

  // Permitir acceso a la ruta /maintenance sin restricción
  if (state.url === '/maintenance' || state.url.startsWith('/maintenance')) {
    console.log('✅ Acceso permitido a ruta de mantenimiento');
    return true;
  }

  // Si está en mantenimiento, redirigir a /maintenance
  // Verificar explícitamente que sea true (no truthy)
  if (config?.en_mantenimiento === true) {
    console.log('🚧 Sitio en mantenimiento, redirigiendo a /maintenance');
    router.navigate(['/maintenance']);
    return false;
  }

  // Permitir acceso si no está en mantenimiento
  console.log('✅ Acceso permitido - sitio NO está en mantenimiento');
  return true;
};
